import React, { useEffect, useState } from 'react';
import api from '../../config/api';
import { getImageUrl } from '../../utils/cdn';
import './AdminSettings.css';

const AdminSettings = () => {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await api.get('/settings');
      setSettings(response.data.settings);
    } catch (error) {
      console.error('Failed to fetch settings:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSettings({
      ...settings,
      [name]: value
    });
  };

  const handleLogoUpload = async (e) => {
    if (!e.target.files[0]) return;

    const formData = new FormData();
    formData.append('logo', e.target.files[0]);

    try {
      setSaving(true);
      await api.put('/settings', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      await fetchSettings();
      alert('Logo updated successfully!');
    } catch (error) {
      alert('Failed to upload logo');
    } finally {
      setSaving(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSaving(true);
      await api.put('/settings', settings);
      alert('Settings saved successfully!');
    } catch (error) {
      alert('Failed to save settings');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="loading">Loading settings...</div>;
  }

  return (
    <div className="admin-settings">
      <h1>Site Settings</h1>
      
      <form onSubmit={handleSubmit} className="settings-form">
        <section>
          <h2>General Settings</h2>
          
          <div className="form-group">
            <label>Site Name</label>
            <input
              type="text"
              name="site_name"
              value={settings.site_name || ''}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Site Logo</label>
            {settings.site_logo && (
              <div className="logo-preview">
                <img src={getImageUrl(settings.site_logo)} alt="Logo" />
              </div>
            )}
            <input
              type="file"
              accept="image/*"
              onChange={handleLogoUpload}
            />
          </div>

          <div className="form-group">
            <label>Site Description</label>
            <input
              type="text"
              name="site_description"
              value={settings.site_description || ''}
              onChange={handleChange}
            />
          </div>
        </section>

        <section>
          <h2>Homepage Content</h2>
          
          <div className="form-group">
            <label>Homepage Title</label>
            <input
              type="text"
              name="homepage_title"
              value={settings.homepage_title || ''}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Homepage Description</label>
            <textarea
              name="homepage_description"
              value={settings.homepage_description || ''}
              onChange={handleChange}
              rows="3"
            />
          </div>
        </section>

        <section>
          <h2>Contact Information</h2>
          
          <div className="form-group">
            <label>Contact Email</label>
            <input
              type="email"
              name="contact_email"
              value={settings.contact_email || ''}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Contact Phone</label>
            <input
              type="text"
              name="contact_phone"
              value={settings.contact_phone || ''}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Contact Address</label>
            <textarea
              name="contact_address"
              value={settings.contact_address || ''}
              onChange={handleChange}
              rows="3"
            />
          </div>
        </section>

        <section>
          <h2>Social Media</h2>
          
          <div className="form-group">
            <label>Facebook URL</label>
            <input
              type="url"
              name="facebook_url"
              value={settings.facebook_url || ''}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Instagram URL</label>
            <input
              type="url"
              name="instagram_url"
              value={settings.instagram_url || ''}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Twitter URL</label>
            <input
              type="url"
              name="twitter_url"
              value={settings.twitter_url || ''}
              onChange={handleChange}
            />
          </div>
        </section>

        <section>
          <h2>Footer</h2>
          
          <div className="form-group">
            <label>Footer Text</label>
            <input
              type="text"
              name="footer_text"
              value={settings.footer_text || ''}
              onChange={handleChange}
            />
          </div>
        </section>

        <button type="submit" className="btn btn-primary" disabled={saving}>
          {saving ? 'Saving...' : 'Save Settings'}
        </button>
      </form>
    </div>
  );
};

export default AdminSettings;

